<div class="one" fxLayout="column" [formGroup]="matterdetailForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MATTERTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MATTERTYPE),
      }"
    >
      <mat-label>Matter Type</mat-label>
      <input
        type="text"
        placeholder="Matter Type"
        matInput
        name="MATTERTYPE"
        formControlName="MATTERTYPE"
        [matAutocomplete]="auto1"
        matTooltip="{{ toolTipList ? toolTipList.MATTERTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-autocomplete #auto1="matAutocomplete">
        @for (val of MatterType; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (testBool && toolTipList.MATTERTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.MATTERTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MATTERTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CLIENTSOURCE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CLIENTSOURCE),
      }"
    >
      <mat-label>Client Source</mat-label>
      <input
        type="text"
        placeholder="Client Source"
        matInput
        name="CLIENTSOURCE"
        formControlName="CLIENTSOURCE"
        [matAutocomplete]="auto2"
        matTooltip="{{ toolTipList ? toolTipList.CLIENTSOURCE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-autocomplete #auto2="matAutocomplete">
        @for (val of ClientSource; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (testBool && toolTipList.CLIENTSOURCE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CLIENTSOURCE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CLIENTSOURCE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FIELDOFLAW),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FIELDOFLAW),
      }"
    >
      <mat-label>Field Of Law</mat-label>
      <input
        type="text"
        placeholder="Field Of Law"
        aria-label="Number"
        matInput
        name="FIELDOFLAW"
        formControlName="FIELDOFLAW"
        [matAutocomplete]="auto3"
        matTooltip="{{ toolTipList ? toolTipList.FIELDOFLAW?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.FIELDOFLAW) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FIELDOFLAW.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.FIELDOFLAW?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <mat-autocomplete #auto3="matAutocomplete">
        @for (val of FiledOfLaw; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FIELDOFLAW),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FIELDOFLAW),
      }"
    >
      <mat-label>Industry</mat-label>
      <input
        type="text"
        placeholder="Industry"
        matInput
        name="INDUSTRY"
        formControlName="INDUSTRY"
        [matAutocomplete]="auto4"
        matTooltip="{{ toolTipList ? toolTipList.INDUSTRY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.INDUSTRY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.INDUSTRY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.INDUSTRY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <mat-autocomplete #auto4="matAutocomplete">
        @for (val of Industry; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="60"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.REFERRERGUID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REFERRERGUID),
      }"
    >
      <mat-label>Referrer</mat-label>
      <input
        matInput
        readonly
        formControlName="REFERRERNAME"
        matTooltip="{{ toolTipList ? toolTipList.REFERRERGUID?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.REFERRERGUID) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.REFERRERGUID.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.REFERRERGUID?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <mat-icon
        matSuffix
        (click)="ContactMatter()"
        [ngClass]="
          appPermissions?.[3]?.Access == 0 ? 'disabled-click large-button' : 'large-button'
        "
      >
        <!-- <img src="assets/icons/web_app/icon_contact_d.ico"> -->
        @if (currentUser?.THEMECOLOUR == 'theme-default') {
          <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
        }
        @if (currentUser?.THEMECOLOUR == 'theme-yellow-light') {
          <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
        }
        @if (currentUser?.THEMECOLOUR == 'theme-blue-gray-dark') {
          <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
        }
        @if (currentUser?.THEMECOLOUR == 'theme-pink-dark') {
          <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
        }
      </mat-icon>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="40"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ARCHIVENO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ARCHIVENO),
      }"
    >
      <mat-label>Archive No</mat-label>
      <input
        matInput
        formControlName="ARCHIVENO"
        matTooltip="{{ toolTipList ? toolTipList.ARCHIVENO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.ARCHIVENO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ARCHIVENO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ARCHIVENO?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="40"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ARCHIVEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ARCHIVEDATE),
      }"
    >
      <mat-label>Archive Date</mat-label>
      <input
        (dateInput)="ArchiveDate('input', $event)"
        formControlName="ARCHIVEDATETEXT"
        (dateChange)="ArchiveDate('change', $event)"
        matInput
        [matDatepicker]="picker4"
        matTooltip="{{ toolTipList ? toolTipList.ARCHIVEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
      <mat-datepicker #picker4></mat-datepicker>
      @if (testBool && toolTipList.ARCHIVEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ARCHIVEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ARCHIVEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <div fxFlex="18" class="button-class pr-1">
      <button
        matButton="filled"
        class="mat-accent"
        [disabled]="loadArchiveno"
        (click)="ArchiveNow()"
      >
        @if (loadArchiveno) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Archive Now
      </button>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ARCHIVEDESTROYEDDUEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ARCHIVEDESTROYEDDUEDATE),
      }"
    >
      <mat-label>Archive Destroy Due Date</mat-label>
      <!-- <input matInput formControlName="ARCHIVEDESTROYEDDUEDATE " matTooltip="{{(toolTipList)?toolTipList.ARCHIVEDESTROYEDDUEDATE :''}}"
                    [matTooltipPosition]="toolTipPostion"> -->
      <input
        (dateInput)="ArchiveDestroyDueDate('input', $event)"
        formControlName="ARCHIVEDESTROYEDDUEDATETEXT"
        (dateChange)="ArchiveDestroyDueDate('change', $event)"
        matInput
        [matDatepicker]="picker5"
        matTooltip="{{ toolTipList ? toolTipList.ARCHIVEDESTROYEDDUEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
      <mat-datepicker #picker5></mat-datepicker>
      @if (testBool && toolTipList.ARCHIVEDESTROYEDDUEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ARCHIVEDESTROYEDDUEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ARCHIVEDESTROYEDDUEDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ARCHIVEDESTROYEDDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ARCHIVEDESTROYEDDATE),
      }"
    >
      <mat-label>Archive Destroyed Date</mat-label>
      <input
        (dateInput)="ArchiveDestroyedDate('input', $event)"
        formControlName="ARCHIVEDESTROYEDDATETEXT"
        (dateChange)="ArchiveDestroyedDate('change', $event)"
        matInput
        [matDatepicker]="picker6"
        matTooltip="{{ toolTipList ? toolTipList.ARCHIVEDESTROYEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
      <mat-datepicker #picker6></mat-datepicker>

      @if (testBool && toolTipList.ARCHIVEDESTROYEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ARCHIVEDESTROYEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ARCHIVEDESTROYEDDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  @if (action == 'edit' && currentUser?.DOCUMENTSYSTEM != 'NetDocuments') {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="100"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.DOCUMENTFOLDER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REFERRERGUID),
        }"
      >
        <mat-label>Document Folder</mat-label>
        <input
          matInput
          readonly
          formControlName="DOCUMENTFOLDER"
          matTooltip="{{ toolTipList ? toolTipList.DOCUMENTFOLDER?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        @if (testBool && toolTipList.DOCUMENTFOLDER) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.DOCUMENTFOLDER.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.DOCUMENTFOLDER?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
        <mat-icon matSuffix (click)="RestFolderPath()" class="reset-path-btn float-left">
          close
        </mat-icon>
        <mat-icon matSuffix (click)="OpenFolderListPopup()" class="float-right ml-2">
          <img src="assets/icons/web_app/Matter Folder Icon.svg" />
        </mat-icon>
      </mat-form-field>
    </div>
  }
  @if (action == 'edit' && currentUser?.DOCUMENTSYSTEM == 'NetDocuments') {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="100"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.NETDOCSWORKSPACEID),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NETDOCSWORKSPACEID),
        }"
      >
        <mat-label>NetDocuments Workspace Id</mat-label>
        <input
          matInput
          formControlName="NETDOCSWORKSPACEID"
          matTooltip="{{ toolTipList ? toolTipList.NETDOCSWORKSPACEID?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        @if (testBool && toolTipList.NETDOCSWORKSPACEID) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.NETDOCSWORKSPACEID.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.NETDOCSWORKSPACEID?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  }
</div>
